<template>
  <div>
    <b-row style="min-width: 100px">
      <b-col>
        <v-select
          v-model="DEPOID"
          :options="ANADEPOOPTION"
          label="DESCRIPTION"
          autocomplete
          size="small"
          :menu-props="{ top: true, offsetY: true }"
          @input="setSecilen"
        >
        </v-select>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import state from "../../../store/state";
import Store from "../../../store/store";
import vSelect from "vue-select";
export default {
  data() {
    return {
      ANADEPOOPTION: [],
      DEPOID: "",
      data: ""
    };
  },
  components: { "v-select": vSelect },
  created() {
    this.getTanimList();
    this.DEPOID = { DESCRIPTION: this.params.data.DEPOIDCODE };
  },
  methods: {
    getValue() {
      return this.data;
    },
    setData(data) {
      this.data = data;
    },
    setSecilen() {
      this.setData(this.DEPOID.DEPOTNAME);
      this.$root.$emit("setDepoData", this.DEPOID, this.params.rowIndex);
    },
    getTanimList() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        COMPANYID: state.MusteriId,
        ROOT: "",
        ROOTFIELD: "DEPOTID"
      };
      soap.createClient(url, function(err, client) {
        client.TANIMLIST(args, function(err, result) {
          if (result.TANIMLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.TANIMLISTResult);
          vm.ANADEPOOPTION = vm.veriler;
        });
      });
    }
  }
};
</script>
<style lang="scss">
[dir] .vs__dropdown-menu {
  z-index: 112323665656565655656;
}
</style>
